import { GET_PLAME_REPORT_BY_FILTER, GENERATE_PLAME_REPORT } from '@/graphql/reports/plame'

// models
import { ReportPlame, ReportPlameItemBase } from '@/models/reports/ReportPlame'

// apollo
import { apolloClient } from '@/apollo'

class ReportPlameService {
    async getPlameReportByFilter (year: number, month: number): Promise<ReportPlame|null> {
        const result = await apolloClient.query({
            query: GET_PLAME_REPORT_BY_FILTER,
            variables: {
                year,
                month
            }
        })
        return result.data.getPlameReportByFilter
    }

    async generatePlameReport (year: number, month: number): Promise<ReportPlameItemBase[]> {
        const result = await apolloClient.mutate({
            mutation: GENERATE_PLAME_REPORT,
            variables: {
              year,
              month
            }
        })
        return result.data.generatePlameReport
    }
}

export default new ReportPlameService()
